module.exports = __webpack_public_path__ + "static/media/8en.8f559424.jpg";